import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import Icon from "@mui/material/Icon";
import { Helmet } from "react-helmet-async";
import { useTranslation } from "react-i18next";
import PointieBox from "../../../components/PointieBox";
import PointieTypography from "../../../components/PointieTypography";

const HowItWorks = () => {
  const { t } = useTranslation("home");

  const steps = [
    {
      icon: "download",
      title: t("howItWorks.step1Title"),
      desc: t("howItWorks.step1Desc"),
      color: "#1a73e8",
    },
    {
      icon: "shopping_cart",
      title: t("howItWorks.step2Title"),
      desc: t("howItWorks.step2Desc"),
      color: "#7B2DC0",
    },
    {
      icon: "savings",
      title: t("howItWorks.step3Title"),
      desc: t("howItWorks.step3Desc"),
      color: "#00897B",
    },
  ];

  const howToJsonLd = {
    "@context": "https://schema.org",
    "@type": "HowTo",
    name: t("howItWorks.title"),
    description: t("howItWorks.subtitle"),
    step: steps.map((s, i) => ({
      "@type": "HowToStep",
      position: i + 1,
      name: s.title,
      text: s.desc,
    })),
  };

  return (
    <PointieBox component="section" py={4}>
      <Helmet>
        <script type="application/ld+json">{JSON.stringify(howToJsonLd)}</script>
      </Helmet>
      <Container>
        <PointieTypography variant="h3" textAlign="center" mb={1}>
          {t("howItWorks.title")}
        </PointieTypography>
        <PointieTypography variant="body2" color="text" textAlign="center" mb={4}>
          {t("howItWorks.subtitle")}
        </PointieTypography>
        <Grid container spacing={4} justifyContent="center">
          {steps.map((s, i) => (
            <Grid item xs={12} md={4} key={s.icon}>
              <PointieBox textAlign="center" px={2}>
                <PointieBox
                  sx={{
                    width: 64,
                    height: 64,
                    borderRadius: "50%",
                    bgcolor: s.color,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    mx: "auto",
                    mb: 2,
                  }}
                >
                  <Icon sx={{ color: "#fff", fontSize: 30 }}>{s.icon}</Icon>
                </PointieBox>
                <PointieTypography variant="caption" color="text" fontWeight="bold" mb={0.5}>
                  {t("howItWorks.stepLabel", { number: i + 1 })}
                </PointieTypography>
                <PointieTypography variant="h5" component="h4" mb={1}>
                  {s.title}
                </PointieTypography>
                <PointieTypography variant="body2" color="text">
                  {s.desc}
                </PointieTypography>
              </PointieBox>
            </Grid>
          ))}
        </Grid>
      </Container>
    </PointieBox>
  );
};

export default HowItWorks;
